import {
  SET_VISIBLE_FIELDS,
  SAVE_DETAILS_FIELD_ORDER_SUBMIT,
  RESET_DETAILS_FIELDS_TO_DEFAULT_SUBMIT,
  SET_ADMIN_VISIBLE_FIELDS,
  SAVE_ADMIN_DETAILS_FIELD_ORDER_SUBMIT,
  RESET_ADMIN_DETAILS_FIELDS_TO_DEFAULT_SUBMIT
} from 'Profiles/constants/detailsFields'

export const setVisibleFields = ({ profileType, fields }) => ({
  type: SET_VISIBLE_FIELDS,
  payload: { profileType, fields }
})

export const saveDetailsFieldOrder = ({ profileType }) => ({
  type: SAVE_DETAILS_FIELD_ORDER_SUBMIT,
  payload: { profileType }
})

export const resetDetailsFieldsToDefault = ({ profileType }) => ({
  type: RESET_DETAILS_FIELDS_TO_DEFAULT_SUBMIT,
  payload: { profileType }
})

export const setAdminVisibleFields = ({ profileType, fields }) => ({
  type: SET_ADMIN_VISIBLE_FIELDS,
  payload: { profileType, fields }
})

export const saveAdminDetailsFieldOrder = ({ profileType }) => ({
  type: SAVE_ADMIN_DETAILS_FIELD_ORDER_SUBMIT,
  payload: { profileType }
})

export const resetAdminDetailsFieldsToDefault = ({ profileType }) => ({
  type: RESET_ADMIN_DETAILS_FIELDS_TO_DEFAULT_SUBMIT,
  payload: { profileType }
})
